export default __webpack_public_path__ + "static/media/background.1dbc2dcd.webp";